import * as React from 'react';

interface containerProps {
  onChange: (isChecked: boolean) => void
  isChecked: boolean
  label: string
  display: 'inline' | 'none';
  title: string;
}


export const ControlledCheckbox: React.FC<containerProps> = ({ onChange, isChecked, label, display, title }) => {

  return (
    <div style={{ cursor: 'pointer' }} onClick={() => { onChange(!isChecked) }} title={title}>
      <i className={isChecked ? "fas fa-check-square" : "far fa-square"} style={{ display }}></i>&nbsp;{label}
    </div>
  );
};